'use strict';

exports.Flex = require('./Flex');
exports.FlexItem = require('./FlexItem');


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-flex/lib/index.js
// module id = 1030
// module chunks = 0